import { memberConstants } from "./types";

const initialState = {
  info: [],
  members: [],
  membersInfoLoading: false,
  account: null,
  agent: null,
  drawIsOpen: false,
  freezeIsOpen: false,
  file: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case memberConstants.MEMBER_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case memberConstants.ACCOUNT_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case memberConstants.MEMBERS_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case memberConstants.MEMBERS_INFO_REQUEST:
      return {
        ...state,
        membersInfoLoading: true,
      };
    case memberConstants.MEMBERS_INFO_SUCCESS:
      return {
        ...state,
        membersInfoLoading: false,
        ...action.payload,
      };
    case memberConstants.MEMBERS_INFO_FAILURE:
      return {
        ...state,
        membersInfoLoading: false,
      };
    case memberConstants.MEMBER_NUMBER:
      return {
        ...state,
        ...action.payload,
      };
    case memberConstants.DRAW_DETAIL:
      return {
        ...state,
        ...action.payload,
      };
    case memberConstants.HIDE_DRAW_MODAL:
      return {
        ...state,
        drawIsOpen: false,
      };
    case memberConstants.FREEZE_DETAIL:
      return {
        ...state,
        ...action.payload,
      };
    case memberConstants.HIDE_FREEZE_MODAL:
      return {
        ...state,
        freezeIsOpen: false,
      };
    case memberConstants.DOCUMENT_FILE:
      return {
        ...state,
        ...action.payload,
      };
    case memberConstants.DOCUMENT_LINK:
      return {
        ...state,
        ...action.payload,
      };
    case memberConstants.AGENT_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case memberConstants.CONTROL_MEMBER_REQUEST:
      return {
        ...state,
        ...action.payload,
        successFirst: false,
      };
    case memberConstants.CONTROL_MEMBER_SUCCESS:
      return {
        ...state,
        ...action.payload,
        successFirst: true,
        saveMember: false,
        doneMember: false,
      };
    case memberConstants.SAVE_MEMBER_REQUEST:
      return {
        ...state,
        ...action.payload,
        saveMember: false,
        doneMember: false,
      };
    case memberConstants.SAVE_MEMBER_SUCCESS:
      return {
        ...state,
        ...action.payload,
        saveMember: true,
        doneMember: false,
      };
    case memberConstants.RESEND_SMS_NEW_MEMBER_REQUEST:
      return {
        ...state,
        ...action.payload,
      };
    case memberConstants.RESEND_SMS_NEW_MEMBER_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case memberConstants.CONTROL_CARD_CONTACT_INFO_REQUEST:
      return {
        ...state,
        ...action.payload,
        controlContact: false,
      };
    case memberConstants.CONTROL_CARD_CONTACT_INFO_SUCCESS:
      return {
        ...state,
        ...action.payload,
        controlContact: true,
      };
    case memberConstants.SAVE_CARD_CONTACT_INFO_REQUEST:
      return {
        ...state,
        ...action.payload,
        saveContact: false,
      };
    case memberConstants.SAVE_CARD_CONTACT_INFO_SUCCESS:
      return {
        ...state,
        ...action.payload,
        saveContact: true,
      };
    case memberConstants.RESEND_VALIDATECODE_CONTACT_INFO_REQUEST:
      return {
        ...state,
        ...action.payload,
      };
    case memberConstants.RESEND_VALIDATECODE_CONTACT_INFO_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case memberConstants.CLEAR_NEW_MEMBER_REDIRECT:
      return {
        ...state,
        ...action.payload,
        successFirst: false,
        saveMember: false,
        doneMember: true,
      };
    case memberConstants.CLEAR_NEW_MEMBER_DONE:
      return {
        ...state,
        successFirst: false,
        saveMember: false,
        doneMember: false,
      };
    case memberConstants.SEND_NEW_MEMBER_ADDRESS:
      return {
        ...state,
        ...action.payload,
        saveMember: false,
      };
    case memberConstants.CLEAR_CONTACT_INFO_REDIRECT:
      return {
        ...state,
        controlContact: false,
        saveContact: false,
      };
    case memberConstants.MEMBER_ERROR:
      return {
        ...state,
        successFirst: false,
      };
    case memberConstants.EXPENSE_BY_MEMBER_NO_REQUEST:
        return {
          ...state,
          ...action.payload,
        };
    case memberConstants.EXPENSE_BY_MEMBER_NO_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };    
        
    default:
      return state;
  }
};
